/**
 * The `?next=` (or `?return=`) a page may honour — an internal path, or nothing.
 *
 * The old first-run addresses forward to `?next=`, and the old focused profile
 * address opens Your basics over `?return=`. Only a same-origin path is
 * honoured: anything that is not a relative path starting with a single `/` —
 * including a protocol-relative `//evil.example` that would pass a naive
 * leading-slash check — is refused, so the parameter cannot be used as an open
 * redirect.
 */
export function safeInternalNext(raw: string | null | undefined): string | null {
  if (!raw) return null;
  if (!raw.startsWith('/') || raw.startsWith('//')) return null;
  return raw;
}
